import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import {
    Dialog,
    InputGroup
} from '@blueprintjs/core';
import {Translate, I18n} from 'react-redux-i18n';
import classnames from 'classnames';

import {
    setBenchmark as setBenchmarkAction
} from '../Exercise/ExerciseActions';

import {
  closeEditDialog as closeEditDialogAction,
  addBenchmark as addBenchmarkAction,
  deleteBenchmark as deleteBenchmarkAction,
  editBenchmark as editBenchmarkAction,
} from './ExerciseBenchmarkActions';

import styles from './Exercise.module.css';

class ExerciseBenchmarkEditDialog extends Component {
    
    constructor() {
      super();
      
      this.state = {
        bName: "",
        bQuestions: [{title: "", answers: ["Yes", "No"]}],
      }
    }
    
    componentDidUpdate(prevProps) {
      if(this.props.currentBenchmarks[0] && this.props.currentBenchmarks[0] !== prevProps.currentBenchmarks[0]) {
        this.setState({bName: this.props.currentBenchmarks[0].name, bQuestions: this.props.currentBenchmarks[0].questions})
      }
    }
  
    handleEditBenchmark = async () => {
      // TODO: check questions and answers are filled
      try {
        const response = await axios.put('/api/companies/benchmarks', {
          _id: this.props.currentBenchmarks[0]._id,
          name: this.state.bName,
          questions: this.state.bQuestions
        }, {
          headers: {
            'Authorization': window.localStorage.getItem("token"),
          },
          validateStatus: (status) => status < 500
        })
        if(response.status >= 400) {
          // TODO: display error
          return console.warn(response.status, response.data);
        }
        this.props.editBenchmark(this.props.currentBenchmarks[0]._id, response.data);
        this.closeEditBenchmarksDialog();
      } catch (err) {
        console.error(err);
      }
    }
    
    closeEditBenchmarksDialog = () => {
      this.props.closeEditDialog();
    }
    
    render() {
      return (
        <Dialog 
          autoFocus={true}
          canEscapeKeyClose={true}
          canOutsideClickClose={true}
          enforceFocus={true}
          isOpen={this.props.isEditBenchmarkDialogOpen}
          usePortal= {true}
          onClose={this.closeEditBenchmarksDialog}
          title={<span style={{color: 'white'}}><Translate value="exercise.EditBenchmark" /></span>}
        >
          <div className="column col-sm-12" style={{paddingTop: 20, paddingBottom: 20}}>
            <InputGroup
              placeholder="Name"
              value={this.state.bName}
              onChange={(event)=>this.setState({bName: event.target.value})}
              className={classnames(styles.dialogBenchmarkName)}
            />
            {
              this.state.bQuestions.map((q, index)=>(
                <div key={"q-"+index} className={classnames(styles.dialogBenchmarkQuestion)}>
                  <InputGroup
                    placeholder="Question"
                    value={q.title}
                    onChange={(event)=>{
                      event.persist();
                      this.setState((prevState)=>({
                        bQuestions: prevState.bQuestions.reduce((acc, q, i) => {
                          if(index === i) {
                            q.title = event.target.value
                          }
                          acc.push(q);
                          return acc;
                        }, [])
                      }))
                    }}
                    rightElement={
                      <div className={classnames(styles.actionBox)}>
                        <button
                          className={classnames("row", "centered", styles.removeAnswer, "pointer", styles.deleteBtn)}
                          onClick={()=>{
                            this.setState(
                              (prevState)=>({
                                bQuestions: prevState.bQuestions.filter((filterQuestion, filterIndex)=>filterIndex !== index)
                              })
                            )
                          }}
                        ><i className={"fas fa-trash"} /></button>
                        <div className={classnames("column")}>
                          <i className="fas fa-angle-up pointer" onClick={()=>{
                            if(index === 0) return;
                            this.setState((prevState) => {
                              const [movable] = prevState.bQuestions.splice(index, 1);
                              prevState.bQuestions.splice(index - 1, 0, movable)
                              return {bQuestions: prevState.bQuestions}
                            })
                          }} />
                          <i className="fas fa-angle-down pointer" onClick={()=>{
                            if(index === this.state.bQuestions.length - 1) return;
                            this.setState((prevState) => {
                              const [movable] = prevState.bQuestions.splice(index, 1);
                              prevState.bQuestions.splice(index + 1, 0, movable)
                              return {bQuestions: prevState.bQuestions}
                            })
                          }} />
                        </div>
                      </div>
                    }
                  />
                  {
                    q.answers.map((answer, aIndex) => (
                      <div key={"q-"+index+"-a-"+aIndex} className={classnames("row", styles.answerContainer)}>
                        <InputGroup
                          placeholder="Answer"
                          value={answer}
                          className={classnames(styles.answer)}
                          onChange={(event)=>{
                            event.persist();
                            this.setState((prevState)=>({
                              bQuestions: prevState.bQuestions.reduce((acc, q, i) => {
                                if(index === i) {
                                  q.answers[aIndex] = event.target.value
                                }
                                acc.push(q);
                                return acc;
                              }, [])
                          }))}}
                        />
                        <div
                          className={classnames("row", "centered", styles.removeAnswer, "pointer")}
                          onClick={()=>this.setState((prevState)=>{
                            const updated = Array.from(prevState.bQuestions);
                            // remove the answer entry at this index
                            updated[index].answers.splice(aIndex, 1);
                            return { bQuestions: updated }
                          })}
                        >x</div>
                        <div className={classnames("column")}>
                          <i className="fas fa-angle-up pointer" onClick={()=>{
                            if(aIndex === 0) return;
                            this.setState((prevState) => {
                              const [movable] = prevState.bQuestions[index].answers.splice(aIndex, 1);
                              prevState.bQuestions[index].answers.splice(aIndex - 1, 0, movable)
                              return {bQuestions: prevState.bQuestions}
                            })
                          }} />
                          <i className="fas fa-angle-down pointer" onClick={()=>{
                            if(aIndex === this.state.bQuestions[index].answers.length - 1) return;
                            this.setState((prevState) => {
                              const [movable] = prevState.bQuestions[index].answers.splice(aIndex, 1);
                              prevState.bQuestions[index].answers.splice(aIndex + 1, 0, movable)
                              return {bQuestions: prevState.bQuestions}
                            })
                          }} />
                        </div>
                      </div>
                    ))
                  }
                  <button onClick={()=>this.setState((prevState)=>({ bQuestions: prevState.bQuestions.map((bq, mIndex) => {
                    if(mIndex === index) {
                      bq.answers.push("");
                    }
                    return bq;
                  }) }))}><Translate value="exercise.AddAnswer" /></button>
                </div>
              ))
            }
            <button
              className={styles.dialogBenchmarkAddQuestion} 
              onClick={()=>this.setState((prevState)=>({bQuestions: prevState.bQuestions.concat({title: "", answers: ["Yes", "No"]})}))}
            >
              <Translate value="exercise.AddQuestion" />
              <span className={styles.dialogBenchmarkPlusSign}>+</span>
            </button>
            <button
              className="btn btn-primary"
              onClick={this.handleEditBenchmark}
            >
              <Translate value="controls.Edit" />
            </button>
          </div>
        </Dialog>
      )
    }
}

const mapStateToProps = (state)=>({
  isEditBenchmarkDialogOpen: state.exerciseBenchmark.isEditBenchmarkDialogOpen,
  benchmark: state.exercise.benchmark,
  currentBenchmarks: state.exerciseBenchmark.currentBenchmarks,
});

const mapDispatchToProps = {
  setBenchmark: setBenchmarkAction,
  addBenchmark: addBenchmarkAction,
  closeEditDialog: closeEditDialogAction,
  deleteBenchmark: deleteBenchmarkAction,
  editBenchmark: editBenchmarkAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(ExerciseBenchmarkEditDialog);